// extracted by mini-css-extract-plugin
export default {"btnGroup":"RibbonButtonGroup_btnGroup__quOq6"};